export const UPDATE_GAMES_GLOBAL_FREE_SPINS = "UPDATE_GAMES_GLOBAL_FREE_SPINS";
export const UPDATE_GAME_STUDIO_FREE_SPINS = "UPDATE_GAME_STUDIO_FREE_SPINS";

export const updateGamesGlobalFreeSpins = (freeSpinsGames) => ({
    type: UPDATE_GAMES_GLOBAL_FREE_SPINS,
    freeSpinsGames,
});

export const updateGameStudioFreeSpins = (freeSpinsGames) => ({
    type: UPDATE_GAME_STUDIO_FREE_SPINS,
    freeSpinsGames,
});
